/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HotToastService } from '@ngneat/hot-toast';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { PickerOptions, PickerSelectOptions } from 'app/components/data-picker/data-picker.interface';
import { FilePlaceholderOptions } from 'app/components/file-placeholder/file-placeholder.interface';
import { FileUploaderService } from 'app/components/file-uploader/file-uploader.service';
import { MultiModulePickerComponent } from 'app/components/multi-module-picker/multi-module-picker.component';
import { MultiModulePickerService } from 'app/components/multi-module-picker/multi-module-picker.service';
import { TextEditorService } from 'app/components/text-editor/text-editor.service';
import { moduleKey } from 'app/core/constants/constants';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { NotesService } from 'app/core/services/notes/notes.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { ModuleIcon } from 'app/interfaces/module-icon.interface';
import _ from 'lodash';
import { Subscription } from 'rxjs';
import { NoteVisibilityType, ParamKey } from '../notes.interface';
import { DialogModalType, NoteDialogOptions } from './note-dialog.interface';
import { NoteDialogService } from './note-dialog.service';

@Component({
    selector: 'note-dialog',
    templateUrl: './note-dialog.component.html',
    styleUrls: ['./note-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NoteDialogComponent implements OnInit, OnDestroy, AfterViewChecked {
    options: NoteDialogOptions;
    note: any;
    editNoteFormGroup: UntypedFormGroup;
    noteAttachments: any[] = [];
    actualAttachmentCount: number = 0;
    companyPolicy: any = null;
    visibilityOptions: any[] = [];
    selectedVisibility: any = null;
    onUploadStarted: Subscription;
    onUploadFinished: Subscription;
    allModules = ['JOB','CUSTOMER','ORGANIZATION','PROPERTY','ESTIMATES','INVOICE','SERVICE_CONTRACTS','ASSETS','PROJECT'];
    moduleKey = moduleKey;
    drawerType: string = 'multiModulePicker';
    openDrawer: boolean = false;
    drawerModule: string = '';
    onNewAssociationClicked: Subscription;
    paramKey= ParamKey;
    getAssociatedModulesSubscription: Subscription;
    associatedModules: any = {};
    dialogType: DialogModalType = 'NOTE';
    user: any = null;
    allAssociates: any = null;
    moduleUID: string = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        public dialogRef: MatDialogRef<NoteDialogComponent>,
        private localisationService: LocalisationService,
        private noteDialogService: NoteDialogService,
        private fileUploaderService: FileUploaderService,
        private utilityService: UtilityService,
        private textEditorService: TextEditorService,
        private dataCollectorService: DataCollectorService,
        private notesService: NotesService,
        private toast: HotToastService,
        private zuperDialogService: ZuperDialogService,
        private multiModulePickerService: MultiModulePickerService,
        private cref: ChangeDetectorRef,
        private formBuilder: UntypedFormBuilder) {
        this.companyPolicy = this.utilityService.companyPolicy;
        this.editNoteFormGroup = this.formBuilder.group({
            editNoteEditorData: [''],
            noteAttachments: [[]],
            visibilityType: [this.selectedVisibility?.visibilityType]
        });
    }

    ngOnInit(): void {
        this.localisationService.setDefaultLanguage();
        this.user = this.utilityService.user;
        this.options = this.data?.data ?? this.options;
        if(this.data?.data?.dialogType || this.options?.dialogType){
            this.dialogType = this.data?.data?.dialogType ?? this.options?.dialogType;
        }
        this.allAssociates = this.data?.data?.allAssociates;
        this.moduleUID = this.options?.config?.uploaderOptions?.options?.moduleUid ??  this.options?.moduleUID;
        this.updateVisibilityOptions();
        this.subscribeFileUploaderService();
        if(this.options && this.options.note){
            this.getNoteDetails();
        }
        this.associatedModules[ParamKey[this.options?.defaultAssociatedModule]] = [this.options?.defaultAssociatedModuleDetails];
        this.onNewAssociationClicked = this.noteDialogService.onNewAssociationClicked.subscribe((response: any) => {
            if(response){
                this.drawerType = 'multiModulePicker';
                this.openDrawer = true;
                this.multiModulePickerService.setDefaultModule(this.options.defaultAssociatedModule);
                this.multiModulePickerService.setAssociatedModules(this.associatedModules);
                const tabs = this.multiModulePickerService.getTabs();
            }
        });
        this.getAssociatedModulesSubscription = this.multiModulePickerService.associatedModules.subscribe((data: any)=>{
            const combinedModules: any = { ...this.associatedModules, ...data  };
            _.each(_.keys(combinedModules), (module: string)=>{
                if(module && data[module]){
                    this.associatedModules[ParamKey[module.toUpperCase()]] = data[module];
                } else if (module && !data[module]) {
                    this.associatedModules[ParamKey[module.toUpperCase()]] = null;
                }
              });
            this.cref.detectChanges();
        });
        this.drawerModule = this.options?.defaultAssociatedModule;
    }

    updateVisibilityOptions(): void {
        this.visibilityOptions = [{
            displayName: 'Public',
            displayKey: 'notes.panel.visibility.public',
            icon: 'ti ti-world',
            visibilityType: NoteVisibilityType.PUBLIC,
            showIf: this.companyPolicy?.customer_portal_enabled
        }, {
            displayName: 'Internal',
            displayKey: 'notes.panel.visibility.internal',
            icon: 'ti ti-users',
            visibilityType: NoteVisibilityType.INTERNAL,
            showIf: true
        }, {
            displayName: 'Private',
            displayKey: this.dialogType === 'COMMENT'? 'private' : 'text.only_me',
            icon: 'ti ti-lock',
            visibilityType: NoteVisibilityType.PRIVATE,
            showIf: this.options?.note ? this.isCurrentUser(this.options?.note?.created_by) : true
        }, {
            displayName: 'Backoffice Only',
            displayKey: 'text.backoffice_only',
            icon: 'ti ti-user-shield',
            visibilityType: NoteVisibilityType.BACKOFFICE,
            showIf: this.dialogType !== 'COMMENT' && this.user?.role?.role_key !== 'FIELD_EXECUTIVE'
        }];
        this.selectedVisibility = this.visibilityOptions.find((data: any)=> data?.visibilityType === NoteVisibilityType.INTERNAL);
    }

    isCurrentUser(user: any): boolean {
        if (user) {
            return user.user_uid === this.user.user_uid;
        }
        return false;
    }

    ngAfterViewChecked(): void {
        this.textEditorService.focusEditor.next({ canInitialize: true, editorId: this.options?.config?.editorOptions?.options?.editorId });
    }

    getUploadingAttachment(uploader: any): any[] {
        return uploader.queue.filter(value => value.progress !== 100);
    }

    getProperAttachmentDetails(uploadedData: any[]): any[] {
        const data: any[] = [];
        for (let dataIndex: number = 0; dataIndex < uploadedData.length; dataIndex++) {
            for (let index: number = 0; index < this.noteAttachments.length; index++) {
                if (this.noteAttachments[index]?.file && !this.noteAttachments[index]?.isError) {
                    this.noteAttachments[index] = this.getNoteAttachmentModel(uploadedData[dataIndex]);
                    break;
                }
            }
        }
        return data;
    }

    getNoteAttachmentModel(attachment: any): any {
        const attachmentType: string = this.utilityService.getAttachmentExtension(attachment.attachment_path);
        return {
            attachment: attachment.attachment_path,
            attachment_uid: attachment.attachment_uid,
            attachment_name: attachment.attachment_name,
            attachment_size: attachment.attachment_size,
            attachment_type: this.utilityService.getAttachmentTypeEnum(attachmentType)
        };
    }

    subscribeFileUploaderService(): void {
        if (this.options?.config?.uploaderOptions.isEnabled) {
            this.onUploadStarted = this.fileUploaderService.onUploadStarted.subscribe((uploader: any) => {
                const uploadingData: any[] = this.getUploadingAttachment(uploader);
                this.noteAttachments.length = this.actualAttachmentCount;
                this.noteAttachments = [...this.noteAttachments, ...uploadingData];
            });
            this.onUploadFinished = this.fileUploaderService.onUploadFinished.subscribe((data: any) => {
                this.getProperAttachmentDetails(data);
                this.actualAttachmentCount = this.noteAttachments.length;
            });
        }
    }

    updateNoteValues(): void {
        if (this.note) {
            this.noteAttachments = this.note?.attachments ? this.note.attachments : [];
            this.actualAttachmentCount = this.noteAttachments.length;
            const visibilityType = this.notesService.getNoteVisibility(this.note);
            this.selectedVisibility = this.visibilityOptions.find(option => option.visibilityType === visibilityType);
            this.editNoteFormGroup.patchValue({
                'editNoteEditorData': this.note ? this.note.note : '',
                'noteAttachments': this.noteAttachments,
                'visibilityType': this.selectedVisibility.visibilityType
            });
        }
    }

    updateNoteClick(_event: any): void {
        if (this.note) {
            this.editNoteFormGroup.patchValue({ 'noteAttachments': this.noteAttachments });
            const value: any = this.editNoteFormGroup.value;
            const payload = {
                note: value.editNoteEditorData,
                attachments: value.noteAttachments,
                noteUID: this.note.note_uid,
                isPrivate: value.visibilityType === NoteVisibilityType.PRIVATE,
                // is_v2_note: this.note.is_v2_note ? true : false,
                visibleToCustomer: value.visibilityType === NoteVisibilityType.PUBLIC,
                isBackOfficeVisible: value.visibilityType === NoteVisibilityType.PUBLIC || value.visibilityType === NoteVisibilityType.INTERNAL,
                associatedModules: this.associatedModules
            };
            if(this.dialogType === 'COMMENT' && (this.data?.data?.moduleUID || this.options?.moduleUID)){
                payload['request'] = this.data.data.moduleUID || this.options.moduleUID;
            }
            this.noteDialogService.onSubmitClicked.next(payload);
        } else {
            const value: any = this.editNoteFormGroup.value;
            const payload = {
                note: value.editNoteEditorData,
                attachments: this.noteAttachments,
                isPrivate: value.visibilityType === NoteVisibilityType.PRIVATE,
                visibleToCustomer: value.visibilityType === NoteVisibilityType.PUBLIC,
                isBackOfficeVisible: value.visibilityType === NoteVisibilityType.PUBLIC || value.visibilityType === NoteVisibilityType.INTERNAL,
                associatedModules: this.associatedModules
                // is_v2_note: false,
            };
            if(this.dialogType === 'COMMENT' && (this.data?.data?.moduleUID || this.options?.moduleUID)){
                payload['request'] = this.data.data.moduleUID || this.options.moduleUID;
            }
            this.noteDialogService.onSubmitClicked.next(payload);
        }
    }

    getPlaceholderOptions(attachment: any): FilePlaceholderOptions {
        return {
            fileName: attachment?.attachment_name ?? 'Untitled',
            fileSize: attachment?.attachment_size,
            fileType: attachment?.attachment_type,
            fileLink: attachment?.attachment,
            showCloseIcon: true,
            showDownloadIcon: false
        };
    }

    getProgress(width: number): any {
        return {
            'width': width + '%'
        };
    }

    cancelUploading(index: number): void {
        const uploadFile: any = this.noteAttachments[index];
        if (uploadFile) {
            uploadFile.cancel();
            uploadFile.remove();
            this.removeFileFromCollection(index);
        }
    }

    removeFileFromCollection(index: number): void {
        this.noteAttachments.splice(index, 1);
        this.actualAttachmentCount = this.noteAttachments.length;
        this.fileUploaderService.notesPreviewFiles.next(this.noteAttachments);
        this.updateDisable();
    }

    fileEventEmitHandler(event: any, index?: number): void {
        if (event) {
            if (event.type === 'remove') {
                this.removeFileFromCollection(index);
            }
        }
    }

    reupload(attachment: any): void {
        if (attachment) {
            attachment.upload();
        }
    }

    updateDisable(): boolean {
        if (this.options.config.editorOptions.isEnabled && this.options.config.uploaderOptions.isEnabled) {
            if (this.noteAttachments.filter(attachment => attachment && attachment.file).length > 0) {
                return true;
            }
            return !this.editNoteFormGroup.value.editNoteEditorData && !this.noteAttachments.length;
        }
        if (this.options.config.editorOptions.isEnabled) {
            return !this.editNoteFormGroup.value.editNoteEditorData;
        }
        if (this.options.config.uploaderOptions.isEnabled) {
            if (this.noteAttachments.filter(attachment => attachment && attachment.file).length > 0) {
                return true;
            }
            return !this.noteAttachments.length;
        }
        return true;
    }

    selectVisibilityOptions(mode: any): void {
        this.selectedVisibility = mode;
        this.editNoteFormGroup.patchValue({ 'visibilityType': mode.visibilityType });
    }

    ngOnDestroy(): void {
        this.onUploadStarted?.unsubscribe();
        this.onUploadFinished?.unsubscribe();
        this.onNewAssociationClicked.unsubscribe();
        this.getAssociatedModulesSubscription.unsubscribe();
    }


    getAssociatedModuleIcon(module: string): string {
        return ModuleIcon[moduleKey[module]];
    }

    getAssociatedModuleName(module: string, associatedDetails: any): string {
    module = moduleKey[module] ?? module;
        if(!_.isEmpty(associatedDetails)){
            switch(module){
                case 'JOB':
                    return `${associatedDetails?.work_order_number?associatedDetails?.work_order_number+' - ':''}${associatedDetails?.job_title}`;
                case 'CUSTOMER':
                    return `${associatedDetails?.customer_first_name} ${associatedDetails?.customer_last_name ?? ''}`;
                case 'ORGANIZATION':
                    return `${associatedDetails?.organization_name}`;
                case 'PROPERTY':
                    return `${associatedDetails?.property_name}`;
                case 'ESTIMATES':
                case 'ESTIMATE':
                    return `${associatedDetails?.prefix?associatedDetails?.prefix+' - ':''}${associatedDetails?.estimate_no || ''}`;
                case 'INVOICE':
                    return `${associatedDetails?.prefix?associatedDetails?.prefix+' - ':''}${associatedDetails?.invoice_no || ''}`;
                case 'ASSETS':
                    return `${associatedDetails?.asset_code?associatedDetails?.asset_code+' - ':''}${associatedDetails?.asset_name ?? ''}`;
                case 'SERVICE_CONTRACT':
                case 'SERVICE_CONTRACTS':
                    return `${associatedDetails.contract_number?associatedDetails.contract_number+' - ':''}${associatedDetails?.contract_name}`;
                case 'PROJECT':
                    return `${associatedDetails?.project_prefix ? (associatedDetails?.project_prefix+' - '):''}${associatedDetails?.project_number ? (associatedDetails.project_number + ' - '): ''}${associatedDetails?.project_name}`;
            }
        }
    }

    checkModuleIsAssociated(module?: any): boolean{
        if(this.associatedModules && this.associatedModules[ParamKey[module]]){
            return true;
        }
        else{
            return false;
        }
    }

    getNoteDetails(): void{
        this.dataCollectorService.getData(this.notesService.updateUrl(this.notesService.notesUrl,this.options.note.note_uid))
        .subscribe((response: any)=>{
            this.note = response.data;
            if(this.note && this.note.is_v2_note){
                this.visibilityOptions = [{
                    displayName: 'Internal',
                    displayKey: 'notes.panel.visibility.internal',
                    icon: 'ti ti-users',
                    visibilityType: NoteVisibilityType.INTERNAL,
                    showIf: true
                }, {
                    displayName: 'Private',
                    displayKey: 'text.only_me',
                    icon: 'ti ti-lock',
                    visibilityType: NoteVisibilityType.PRIVATE,
                    showIf: true
                }];
                this.selectedVisibility = this.visibilityOptions[1];
            }
            _.each(_.keys(this.note), (data: any)=>{
                if(ParamKey[data.toUpperCase()] && this.note[data]){
                    this.associatedModules[data]= [this.note[data]];
                }
            });
            this.updateNoteValues();
        }, (_error: any)=>{
        });
    }

    openAssociationsDrawer(): void{
        this.noteDialogService.onNewAssociationClicked.next(true);
    }

    getMultiModulePickerOptions(): PickerOptions {
        return {
          header: {
            displayKey: 'notes.associated_with.title',
            displayName: 'Associated with'
          },
          showListCount: true,
          position: 'right',
          mode: 'over',
          hasBackDrop: false,
          allowQuickCreate: false,
          selectOption: PickerSelectOptions.select,
          footer: {
            displayKey: 'proceed',
            displayName: 'Proceed'
          },
          isFromNote: true,
        };
    }

    multiModulePickerPickerEventHandler(event: any): void {
        if (event.drawerClosed) {
          this.openDrawer = false;
          this.drawerType = '';
        }
    }

    attachmentsAdded(attachment): any{
        this.noteAttachments = [...this.noteAttachments,...attachment];
        this.editNoteFormGroup.patchValue({ 'noteAttachments': this.noteAttachments });
    }
}
